<template lang="pug">
table-base.study-result-resolve-table
  table-row-base.study-result-resolve-table__row
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='problemNumberHeader')
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='questionTypeHeader')
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='correctAnswerHeader')
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='correctSymbolHeader')
    table-header-base.study-result-resolve-table__row__header.align-center
      slot(name='resolveCorrectSymbolHeader')
    //- 解きなおすボタン列は一時コメントアウト
    //- table-header-base.study-result-resolve-table__row__header.align-center
    //-   slot(name='retryHeader')
  table-row-base.study-result-resolve-table__row(v-for='(detail, index) in studyResultResolves', :key='`id_${index}`')
    table-data-base.study-result-resolve-table__row__cell.align-center {{ detail.problemNumberText }}
    table-data-base.study-result-resolve-table__row__cell.align-center {{ detail.questionNumberText }}
    table-data-base.study-result-resolve-table__row__cell.align-center {{ detail.questionType }}
    table-data-base.study-result-resolve-table__row__cell.align-center(v-html='detail.correctAnswer')
    table-data-base.study-result-resolve-table__row__cell.align-center {{ detail.correctSymbol }}
    table-data-base.study-result-resolve-table__row__cell.align-center(:data-changed='detail.isChanged') {{ detail.resolveCorrectSymbol }}
    //- table-data-base.study-result-resolve-table__row__cell.align-center
    //-   button-primary.study-result-resolve-table__row__cell__button(@click='retryEachButtonEvent(detail.problemNumber, detail.questionNumber)')
    //-     slot(name='retryEachButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import { StudyResultResolveType } from '@/models/studyResultDetailModel'

/**
 * テスト結果解きなおし詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ButtonPrimary,
  },
})
export default class StudyResultResolveTable extends Vue {
  // テスト結果解きなおし詳細表示情報
  @Prop()
  studyResultResolves!: StudyResultResolveType[]

  // 項目毎の解きなおすボタン押下時イベント
  @Prop()
  retryEachButtonEvent!: Function
}
</script>

<style lang="stylus" scoped>
.study-result-resolve-table
  width 100%

  &__row
    &__header, &__cell
      width calc(100% / 6)
      border 1px solid var(--color-study-list-table__border)

    &__header
      padding 5px
      background-color var(--color-study-list-head__background)
      color var(--color-study-list-head__text)

    &__cell
      padding 10px

      &[data-changed='true']
        color var(--color-study-list-annotation__text)
</style>
